import { cn } from '@/lib/utils'

export function KpiStatCard({
	icon,
	iconClass,
	label,
	value,
	sub,
}: {
	icon: React.ReactNode
	iconClass: string
	label: string
	value: string
	sub?: string
}) {
	return (
		<div className="rounded-lg border border-kaefer-light-silver bg-white p-4">
			<div
				className={cn(
					'flex size-8 items-center justify-center rounded-md',
					iconClass,
				)}
			>
				{icon}
			</div>
			<p className="mt-2 text-2xl font-bold text-kaefer-dark-grey">{value}</p>
			<p className="text-xs font-medium text-kaefer-dark-grey">{label}</p>
			{sub && <p className="text-[11px] text-muted-foreground">{sub}</p>}
		</div>
	)
}
